import { useSettings } from "~/store/settings";

interface ITranslate {
	key: string;
	options?: {
		// biome-ignore lint/suspicious/noExplicitAny: Variables is unknown, any is acceptable here.
		variables?: { key: string; value: any }[];
		identifier?: string;
		lowercase?: boolean;
		cleaned?: boolean;
		ensureExists?: boolean;
	};
}

const t = (key: ITranslate["key"], options: ITranslate["options"] = { identifier: "", lowercase: true, cleaned: false, ensureExists: false }) => {
	const store = useSettings();
	let _key: string;
	options?.lowercase ? (_key = key.toLowerCase()) : (_key = key);
	options?.identifier && (_key = `${options.identifier.replace(/ /g, "")}${_key}`);
	let value = store.translations?.[_key] ? store.translations[_key] : key;
	if (options?.variables) {
		options.variables.forEach((variable) => {
			if (value.includes("%{")) {
				value = value.replace(new RegExp(`%{${variable.key}}`, "g"), variable.value);
			} else {
				value = value.replace(new RegExp(`{${variable.key}}`, "g"), variable.value);
			}
		});
	}

	if (options.ensureExists && store.translations && !store.translations[_key]) throw new Error("No Translation Match");
	if (store.showTranslations === false && useRuntimeConfig().public.env === "development") value = _key;

	return value;
};

export default t;
